export type VotablePoll = { questions: PollQuestion[] };
type PollChoice = { id: string; voted: boolean; votes_count: number };
type PollQuestion = { choices: PollChoice[]; question_votes: number };

export const patchPollVote = <T extends VotablePoll>(poll: T, choiceId: string, action: 'unvote' | 'vote'): T => {
  const delta = action === 'vote' ? 1 : -1;

  return {
    ...poll,
    questions: poll.questions.map((question) => {
      if (!question.choices.some((choice) => choice.id === choiceId)) {
        return question;
      }

      /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      return {
        ...question,
        choices: question.choices.map((choice) =>
          choice.id === choiceId
            ? { ...choice, voted: action === 'vote', votes_count: choice.votes_count + delta }
            : choice,
        ),
        question_votes: question.question_votes + delta,
      };
      /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
    }),
  };
};
